export default __webpack_public_path__ + "static/media/thumbnail.7d8c6495.png";